import useInterval from './useInterval'
import { useContext, useState } from 'react'
import { Web3Context } from './web3'
import Web3 from 'web3'
import { wait } from '../utils/wait'

export const useCurrentBlock = (updateInterval: number): any => {
  const { web3 } = useContext(Web3Context)
  const [currentBlockNumber, setCurrentBlockNumber] = useState<
    number | undefined
  >(undefined)
  const [currentBlockTimestamp, setCurrentBlockTimestamp] = useState<
    number | undefined
  >(undefined)

  const [nonce, setNonce] = useState(0)

  useInterval(
    async () => {
      if (!web3) {
        setNonce(nonce + 1)
        return
      }

      try {
        const { timestamp, number } = await blockchainCall(web3)

        setCurrentBlockNumber(number)
        setCurrentBlockTimestamp(timestamp)
      } catch (e) {
        // Nonce is updated
        console.error(e)
      }
      setNonce(nonce + 1)
    },
    updateInterval,
    true
  )

  return { currentBlockNumber, currentBlockTimestamp, nonce }
}

async function blockchainCall(
  web3: Web3
): Promise<{ number: number; timestamp: number }> {
  /**
   * When cutting the network, web3.eth.getBlockNumber() never fails for some reasons
   * So we put a timeout. No response after 3 secs means it's a fail
   */

  let resolved = false

  return new Promise(async (resolve, reject) => {
    const timeoutId = setTimeout(() => {
      if (!resolved) {
        reject('web3.eth.getBlockNumber() timeout')
      }
    }, 3000)
    const blockNumber = await web3.eth.getBlockNumber()
    const block = await web3.eth.getBlock(blockNumber)

    // await wait(5000)  // Test to make the web3 call fail
    resolved = true // or almost resolved...

    clearTimeout(timeoutId)

    let timestamp: number
    // Javascript values are all in ms
    if (typeof block.timestamp === 'string') {
      timestamp = parseInt(block.timestamp) * 1000
    } else {
      timestamp = block.timestamp * 1000
    }
    resolve({
      number: blockNumber,
      timestamp: timestamp,
    })
  })
}
